<template>
  <b-nav-item-dropdown
    v-if="languageList.length > 0"
    class="language-content language-select"
    :text="currentLanguage.shortName"
    right>
    <template
      v-for="(language, index) in languageList">
      <b-dropdown-item
        v-if="language !== currentLanguage"
        :key="index"
        :to="language.isDefault ? linkUrl : '/' + language.pathName + linkUrl"
        :class="{'font-kaznet': language.isRtl === 1 || language.isRtl === '1'}">
        {{ language.fullName }}
      </b-dropdown-item>
    </template>
  </b-nav-item-dropdown>
</template>

<script>
export default {
  data() {
    return {
      languageList: [],
      currentLang: {}
    }
  },
  computed: {
    host() {
      return this.$store.state.host;
    },
    linkUrl() {
      return this.$route.params.ln !== undefined
        ? this.$route.fullPath.substring(
            this.$route.fullPath.substring(1).indexOf("/") + 1
          )
        : this.$route.fullPath;
    },
    paramsString() {
      return this.$route.query;
    },
    currentLanguage() {
      let clang = {};

      if (this.$route.params.ln !== undefined) {
        clang =
          this.languageList.length > 0
            ? this.languageList.filter(
                l => l.pathName === this.$route.params.ln
              )[0]
            : clang;
      } else {
        clang = this.currentLang;
      }
      return clang;
    }
  },

  created() {
    this.getSiteSettings();
    this.getLanguageList();
    this.getLanguagePack();
  },

  methods: {
    getSiteSettings() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getsitesettings", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.$store.state.siteSettings = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },
    getLanguagePack() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getlanguagepack", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.$store.state.canload = true;
              this.$store.state.languagePack = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    getLanguageList() {
      this.$http
        .post(
          this.host + "/api/qazlatyn/getlanguagelist",
          new FormData()
        )
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.languageList = result.body.data;
              this.currentLang = result.body.data.filter(l => l.isDefault)[0];
              this.$store.commit("setLanguageList", result.body.data);
              this.$store.commit(
                "setCurrentLanguage",
                result.body.data.filter(l => l.isDefault)[0]
              );
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getSiteSettings();
        this.getLanguagePack();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.language-content {
  .nav-link {
    color: #444444;
    &::after {
      margin-left: 0.375rem;
    }
  }
  .dropdown-menu {
    .dropdown-item {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
}
/* RTL */
.rtl-layout {
  .dropdown-menu-right {
    left: 0 !important;
    right: -6.5rem !important;
  }
}
</style>

<style>
/* RTL */
.rtl-layout .dropdown-menu-right {
  left: 0 !important;
  right: auto !important;
}

/* LTR */
.navigation-content .language-select .nav-link,
.navigation-content .language-select .nav-link:hover,
.navigation-content .language-select .nav-link:focus,
.navigation-content .language-select.show .nav-link {
  color: #ffffff !important;
}
.language-content .dropdown-item.active,
.language-content .dropdown-item.active:hover {
  background-color: #ffffff !important;
  color: #333333;
}
.language-content .dropdown-item:active,
.language-content .dropdown-item:hover,
.language-content .dropdown-item:active:hover {
  background-color: #ffffff !important;
}
.language-content .dropdown-menu {
  min-width: 6.5rem;
  border-radius: 0;
  box-shadow: 0 0 5px #0707076b;
}
</style>
